import { atom } from "recoil";

export default atom({
    default: {
        allowDelivery: false,
        allowCollect: false,
        allowCard: false,
        allowCash: false,
        allowTransfer: false,
        allowSplit: false,
        message: ""
    },
    key: "config-atom"
})